import script from "./LayoutRightPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutRightPanel.vue?vue&type=script&setup=true&lang=js"

import "./LayoutRightPanel.vue?vue&type=style&index=0&id=04482ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04482ac0"]])

export default __exports__